import { IItem } from "../items";
import { AbstractDocumentAlert } from "./AbstractDocumentAlert";

export class ExternalValidateAlert extends AbstractDocumentAlert {
  constructor() {
    super(true);
  }

  get detectedItem(): IItem {
    return null;
  }

  get kind(): string {
    return "システム異常";
  }

  get target(): string {
    return "外部システム";
  }

  get description(): string {
    return "警告判定失敗しました。";
  }

  get itemSetId(): number {
    return null;
  }
}
